import * as React from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { MenuItemLink } from "react-admin";
import { withRouter } from "react-router-dom";

import AppsIcon from "@material-ui/icons/Apps";
import SettingsIcon from "@material-ui/icons/Settings";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import LeakRemoveIcon from "@material-ui/icons/LeakRemove";

import { userHasEveryPermissions, userHasSomePermissions } from "./components/util/permissionsUtils";
import { PermissionIdEnum } from "./components/util/types/permissions/permissionIdEnum";

const Menu = ({ onMenuClick, logout }) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem("user"));

  const features = (user && user?.features) || [];
  const role = user && user.role;

  const permissions = features.length > 0 ? [...features, role] : [role];
  const openDocumentationApp = () => {
    window.open(
      `${process.env.REACT_APP_DOCUMENTATION_CLOUDFRONT_URL}/#token=${encodeURIComponent(user.accessToken)}&userId=${encodeURIComponent(user._id)}`,
      "_blank",
    );
  };

  return (
    <div style={{ marginTop: 30 }}>
      <MenuItemLink
        key="mission-control"
        to="/"
        primaryText={t("menu.missionControl")}
        leftIcon={<AppsIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />

      {/* <MenuItemLink
        key="dashboard"
        to="/kpi"
        primaryText={t("menu.dashboard")}
        leftIcon={<TimelineIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      /> */}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuPoliciesBuildings)) && (
        <MenuItemLink
          key="newpolicies"
          to="/newpolicies"
          primaryText={t("menu.newpolicies")}
          leftIcon={<LocationCityIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuPoliciesAgriculture)) && (
        <MenuItemLink
          key="policiesagriculture"
          to="/policiesagriculture"
          primaryText={t("policy.agricultureMenu")}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuClaimsBuildings)) && (
        <MenuItemLink
          key="newclaims"
          to="/newclaims"
          primaryText={t("menu.newclaims")}
          leftIcon={<LocationCityIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuClaimsAgriculture)) && (
        <MenuItemLink
          key="claimsagriculture"
          to="/claimsagriculture"
          primaryText={t("claims.agricultureMenu")}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuRiskAssessment)) && (
        <MenuItemLink
          to="/riskassessment"
          primaryText={t("menu.riskAssessment")}
          leftIcon={<TrackChangesIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuClimateIndex)) && (
        <MenuItemLink
          to="/climateIndex"
          primaryText={t("menu.climateIndex")}
          leftIcon={<TrackChangesIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {/* {resources.map((resource) => (
        <MenuItemLink
          key={resource.name}
          to={`/${resource.name}`}
          primaryText={menuTitle(resource)}
          leftIcon={createElement(resource.icon)}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      ))*/}

      {/*(permissions.includes("super") || permissions.includes("NOWCAST_MENU")) && (
        <MenuItemLink
          key="nowcast"
          to="/nowcast"
          primaryText={t("menu.nowcast")}
          leftIcon={<WarningIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )*/}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuAnalytics)) && (
        <MenuItemLink
          key="climateAnalytics"
          to="/climateAnalytics"
          primaryText={t("climateAnalytics.analyticsMenu")}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuNatcatAnalytics)) && (
        <MenuItemLink
          key="natcatAnalytics"
          to="/natcatAnalytics"
          primaryText={`NATCAT ${t("climateAnalytics.analyticsMenu")}`}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuAgroAnalytics)) && (
        <MenuItemLink
          key="agroAnalytics"
          to="/agroAnalytics"
          primaryText={`Agri ${t("climateAnalytics.analyticsMenu")}`}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuDashboardKpi)) && (
        <MenuItemLink
          key="kpidashboard"
          to="/kpidashboard"
          primaryText={t("menu.kpiDashboard")}
          leftIcon={<PermMediaIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {userHasSomePermissions(["super", PermissionIdEnum.MenuEmergencyMonitoring]) && (
        <MenuItemLink
          key="emergencyMonitoring"
          to="/emergencyMonitoring"
          primaryText={t("menu.emergencyMonitoring")}
          leftIcon={<LeakRemoveIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {userHasSomePermissions(["super", PermissionIdEnum.MenuMiningAssets]) && (
        <MenuItemLink
          to="/mining"
          primaryText="Mining Assets"
          leftIcon={<TrackChangesIcon />}
          onClick={onMenuClick}
        />
      )}

      {userHasSomePermissions(["super"]) && (
        <MenuItemLink
          to="/eventScope"
          primaryText="Event Scope"
          leftIcon={<TrackChangesIcon />}
          onClick={onMenuClick}
        />
      )}

      {userHasSomePermissions(["super"]) && (
        <MenuItemLink
          to="/documentation"
          primaryText="Documentation"
          leftIcon={<TrackChangesIcon />}
          onClick={openDocumentationApp}
        />
      )}

      {(permissions.includes("super") || permissions.includes(PermissionIdEnum.MenuSettings)) && (
        <MenuItemLink
          to="/settings"
          primaryText={t("menu.settings")}
          leftIcon={<SettingsIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}

      {isXSmall && logout}
    </div>
  );
};

export default withRouter(Menu);
